import { useState } from 'react';

// Brand logo: a tiny dung-beetle-rolling-Earth mark.
// Desktop (hover-capable): hover reveals "VENT"; click opens the origin story.
// Touch (no hover): first tap reveals "VENT"; second tap opens the origin story.
const BrandMark = ({ onOpenStory }) => {
  const [canHover] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(hover: hover)').matches
  );
  const [revealed, setRevealed] = useState(false);

  const handleClick = () => {
    if (canHover) { onOpenStory?.(); return; }
    if (!revealed) { setRevealed(true); return; }
    onOpenStory?.();
  };

  const markOpacity = revealed ? 'opacity-0' : (canHover ? 'group-hover:opacity-0' : '');
  const wordOpacity = revealed ? 'opacity-100' : (canHover ? 'group-hover:opacity-100' : '');

  return (
    <button
      onClick={handleClick}
      className="group relative h-10 w-28 flex items-center cursor-pointer"
      data-testid="brand-logo"
      aria-label="Vent — read the Dung Beetle's adventure"
      title="The Dung Beetle's Adventure"
    >
      {/* Default: tiny beetle rolling a spinning Earth */}
      <span className={`absolute left-0 inset-y-0 flex items-center transition-opacity duration-300 ${markOpacity}`}>
        <span className="relative block w-9 h-9">
          <img
            src="/almanac/planet.png"
            alt=""
            className="w-9 h-9 rounded-full object-cover animate-spin-slow ring-1 ring-white/15 shadow-[0_0_10px_rgba(95,214,230,0.35)]"
          />
          <img
            src="/almanac/beetle.png"
            alt=""
            className="absolute -left-2 -bottom-0.5 w-5 h-5 object-contain drop-shadow-[0_1px_2px_rgba(0,0,0,0.6)] animate-beetle-nudge"
          />
        </span>
      </span>

      {/* Reveal: VENT wordmark */}
      <span className={`absolute left-0 inset-y-0 flex items-center font-adventure font-extrabold text-xl tracking-tight text-white opacity-0 transition-opacity duration-300 whitespace-nowrap ${wordOpacity}`}>
        Vent<span className="text-emerald-400">.</span>
      </span>
    </button>
  );
};

export default BrandMark;
